
import {
  Component,
  Input,
  ElementRef,
  HostListener,
  AfterViewInit,
} from '@angular/core';

@Component({
  selector: 'app-call-out-box',
  imports: [],
  templateUrl: './call-out-box.component.html',
  styleUrl: './call-out-box.component.scss',
})
export class CallOutBoxComponent implements AfterViewInit {
  @Input() icon = '/assets/icons/callout-icon.svg';
  @Input() title?: string;
  @Input() content = '';
  @Input() noMargins = false;

  isTall = false;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.checkHeight();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkHeight();
  }

  private checkHeight() {
    const element = this.elementRef.nativeElement.querySelector('.callout-box');
    this.isTall = element.offsetHeight > 140;
  }
}
